import { Link } from 'react-router-dom';
import { useTranslation } from 'react-i18next';
import { getHotWorks } from '@/mocks/works';
import SectionHeading from '@/components/feature/SectionHeading';

export default function RankingSection() {
  const { t } = useTranslation();
  const works = getHotWorks().slice(0, 8);
  const rankColors = ['bg-primary-500', 'bg-secondary-500', 'bg-accent-600'];

  return (
    <section className="py-12 md:py-16" aria-label={t('sec_ranking')}>
      <div className="mx-auto max-w-7xl px-4 md:px-6">
        <SectionHeading title={t('sec_ranking')} desc={t('sec_ranking_desc')} />

        <ol className="grid grid-cols-1 gap-3 sm:grid-cols-2">
          {works.map((work, idx) => (
            <li key={work.id}>
              <Link
                to={`/category/${work.categories[0]}`}
                className="flex items-center gap-3 rounded-lg border border-background-200/70 bg-background-50 p-3 transition hover:border-primary-300"
              >
                <span
                  className={`flex h-9 w-9 shrink-0 items-center justify-center rounded-md text-base font-bold text-background-50 ${
                    rankColors[idx % 3]
                  }`}
                >
                  {idx + 1}
                </span>
                <div className="h-14 w-10 shrink-0 overflow-hidden rounded-md bg-background-100">
                  <img
                    src={work.cover}
                    alt={work.title}
                    title={`${work.title} 动漫网人气榜`}
                    className="h-full w-full object-cover object-top"
                  />
                </div>
                <div className="min-w-0 flex-1">
                  <h3 className="truncate text-sm font-semibold text-foreground-950 group-hover:text-primary-600">
                    {work.title}
                  </h3>
                  <p className="mt-0.5 truncate text-xs text-foreground-600">
                    {work.tags.join(' · ')}
                  </p>
                </div>
                <div className="flex shrink-0 items-center gap-3">
                  <span className="flex items-center gap-1 text-xs text-foreground-500">
                    <i className="ri-fire-fill text-primary-500" aria-hidden="true"></i>
                    {work.rating.toFixed(1)}
                  </span>
                  <i className="ri-arrow-right-s-line text-foreground-400" aria-hidden="true"></i>
                </div>
              </Link>
            </li>
          ))}
        </ol>
      </div>
    </section>
  );
}